import React from 'react';
import { IBlogItem } from "../interfaces/types";
import dayjs from 'dayjs'

interface BlogListItemProps {
    article: IBlogItem;
}

interface BlogListItemImageProps {
    imageUrl: string;
    cssClass: string;
    url?: string;
}

export const BlogListItemImage: React.FC<BlogListItemImageProps> = ({ imageUrl, cssClass, url }) => {
    if (!imageUrl) return null;
    const image = <img src={imageUrl} alt={''} />;
    return (
        <div className={`blog-listing-image ${cssClass}`}>
            {/* Duplicate of the title link — hidden from keyboard/AT to avoid a second tab stop */}
            {url ? <a href={url} tabIndex={-1} aria-hidden="true">{image}</a> : image}
        </div>
    );
}

export const BlogListItem: React.FC<BlogListItemProps> = ({ article }) => {
    return (
        <div className="grid grid-8-4 blog-listing-item-grid">
            <BlogListItemImage imageUrl={article.image} cssClass="blog-listing-mobile" url={article.url} />
            <div className="blog-listing-info stack-space">
                {article.categories && article.categories.length > 0 ? (
                    <ul role="list" className="blog-listing-tags">
                        {article.categories.map((category) => (
                            <li key={category} className="chip">{category}</li>
                        ))}
                    </ul>
                ) : null}
                <div className="stack-sm">
                    {article.url
                        ? <a href={article.url} className="blog-listing-title">{article.title}</a>
                        : <h3 className="blog-listing-title">{article.title}</h3>}
                    {article.description ? <p>{article.description}</p> : null}
                </div>
                <p className="blog-listing-byline">
                    {article.author ? <>{article.author}<span aria-hidden="true"> | </span></> : null}
                    {dayjs(article.publishDate).format('MMMM D, YYYY')}
                </p>
            </div>
            <BlogListItemImage imageUrl={article.image} cssClass="blog-listing-desktop" url={article.url} />
        </div>
    )
}
